import { AppProviders } from './providers/AppProviders'
import { AppRouter } from './AppRouter'
import { Toaster } from 'sonner'


export default function App() {
  return (
    <AppProviders>
      <div className="app-root">
        <AppRouter />
        <Toaster richColors position="top-right" closeButton />
      </div>
    </AppProviders>
  )
}
